module.exports = "//static.hsappstatic.net/AdsUI/static-1.36835/imgs/ads-optimization-video.png"